module.exports = __webpack_public_path__ + "static/media/postcard8thumb.88df23d8.jpg";